import { useQuery } from '@tanstack/react-query';

import { type ApprovalRequestStatus, listApprovalRequests } from '~/services/LuxLoyalty';

import { claimsQueryKeys } from './claimsQueryKeys';

const DEFAULT_PAGE_SIZE = 25;

export function useGetApprovalRequests(
  campaignId: string | null,
  status?: ApprovalRequestStatus,
  page = 0,
  pageSize = DEFAULT_PAGE_SIZE,
  customerId?: string,
) {
  return useQuery({
    queryKey: claimsQueryKeys.approvalRequests(campaignId ?? '', status, page, pageSize, customerId),
    queryFn: ({ signal }) =>
      listApprovalRequests(
        campaignId,
        {
          ...(status ? { status } : {}),
          ...(customerId ? { customerId } : {}),
          limit: String(pageSize),
          offset: String(page * pageSize),
        },
        { signal },
      ),
    select: (data) => data.result,
    enabled: !!campaignId,
  });
}
